import React, { useEffect, useState, useRef } from "react";
import { useDebounce } from "use-debounce";
import Constants from "../Constants";
import Loading from "./Loading";
//import ModelItem from "./quicksearch/ModelItem";
import ModelItemLarge from "./quicksearch/ModelItemLarge";
import TagItem from "./quicksearch/TagItem";
const Search = ({ setShowSearch, csrf }) => {
  const [searchItem, setSearchItem] = useState("");
  const [max, setMax] = useState(8);
  const [maxTag, setMaxTag] = useState(4);
  const [term] = useDebounce(searchItem, 350);
  const [searching, setSearching] = useState(false);
  const [quickSearchModels, setQuickSearchModels] = useState([]);
  const [quickSearchTags, setQuickSearchTags] = useState([]);
  const previousSearch = useRef(null);
  const typeRef = useRef(null);
  useEffect(() => {
    if (typeRef && typeRef.current) {
      setTimeout(() => {
        typeRef.current.focus();
      }, 350);
    }
  }, [typeRef]);
  useEffect(() => {
    if (term !== "" && term.replace(/ /g, "") !== "" && term.length > 2) {
      //previous is ab
      //term is abc
      //if term includes pervious don't fetch just resort already fetched...
      if (
        previousSearch.current &&
        previousSearch.current ===
          term.substring(0, previousSearch.current.length)
      ) {
        previousSearch.current = term;
        setQuickSearchModels((prev) => {
          const filtered = prev.filter((p) =>
            p.model_name.toLowerCase().includes(term),
          );
          if (filtered.length > 0) {
            return filtered;
          }
          return [];
        });
        setQuickSearchTags((prev) => {
          return prev.filter((p) => p.tag_name.toLowerCase().includes(term));
        });
      } else {
        setSearching(true);
        const formData = new FormData();
        formData.append("term", term);
        fetch(`${Constants.API}quick-searching`, {
          credentials: "include",
          method: "POST",
          headers: {
            "X-XSRF-TOKEN": csrf,
          },
          body: formData,
        })
          .then((res) => res.json())
          .then((res) => {
            //do something..
            previousSearch.current = term;
            setQuickSearchModels(res.models);
            setQuickSearchTags(res.tags);
            setSearching(false);
          });
      }
    } else {
      setSearching(false);
      setQuickSearchModels([]);
      setQuickSearchTags([]);
    }
  }, [term, csrf]);
  useEffect(() => {
    document.body.classList.add("open");
    return () => document.body.classList.remove("open");
  }, []);
  return (
    <div className="search">
      <div className="cols">
        <div className="col second">
          <button type="submit" className="button_send">
            <i className="icon-search"></i>
          </button>
        </div>
        <div className="col">
          <input
            type="text"
            className="input"
            defaultValue={""}
            placeholder="Search..."
            ref={typeRef}
            onChange={(e) => setSearchItem(e.target.value.toLowerCase())}
          />

          <div className="drop_search">
            {!quickSearchModels?.length &&
            !quickSearchTags?.length &&
            term !== "" &&
            !searching ? (
              <div className="noQuickSearchResults">
                {term.length > 2 ? "No Results" : "Type at least 3 characters"}{" "}
                <span role="img" aria-label="Sad but Relieved Face">
                  😥
                </span>
              </div>
            ) : null}
            {quickSearchModels?.length > 0 || searching ? (
              <div className="block modelBlock">
                <h3 className="title">Models</h3>
                {searching ? (
                  <div className="row">
                    <div
                      className="loadingScreen noHeight"
                      style={{ margin: "0px auto" }}
                    >
                      <Loading size="la" extra="" />
                    </div>
                  </div>
                ) : (
                  <div className="model_search">
                    {quickSearchModels?.slice(0, max).map((model) => (
                      <ModelItemLarge
                        model={model}
                        setShowSearch={setShowSearch}
                      />
                    ))}
                  </div>
                )}
                {quickSearchModels?.length > max ? (
                  <div
                    className="search_more"
                    onClick={() => setMax(quickSearchModels?.length)}
                  >
                    + {quickSearchModels?.length - max} more results
                  </div>
                ) : null}
              </div>
            ) : null}
            {quickSearchTags?.length > 0 || searching ? (
              <div className="block">
                <h3 className="title">Tags</h3>
                {searching ? (
                  <div className="row">
                    <div
                      className="loadingScreen noHeight"
                      style={{ margin: "0px auto" }}
                    >
                      <Loading size="la" extra="" />
                    </div>
                  </div>
                ) : (
                  quickSearchTags
                    ?.slice(0, maxTag)
                    .map((tag) => (
                      <TagItem tag={tag} setShowSearch={setShowSearch} />
                    ))
                )}
              </div>
            ) : null}
            {quickSearchTags?.length > 4 && maxTag === 4 ? (
              <div
                className="search_more pad"
                onClick={() => setMaxTag(quickSearchTags?.length - 1)}
              >
                + {quickSearchTags?.length - 4} more results
              </div>
            ) : null}
          </div>
        </div>
        <div className="col second">
          <button
            type="button"
            className="button_close"
            onClick={() => setShowSearch(false)}
          >
            <i className="icon-close"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Search;
